import * as React from "react";
const AddItemSmall = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 23 23", fill: "currentColor", width: size || "23", height: size || "23", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11.026 11L11 0h.974L12 11h11v1H12l-.026 11H11l.026-11H0v-1z" }));
AddItemSmall.displayName = "AddItemSmall";
var AddItemSmall_default = AddItemSmall;
export {
  AddItemSmall_default as default
};
